/** 모달 ALERT **/
import ALERT from '@/components/common/modal/alert/alert/alert.vue';
import AGE_MODAL from '@/components/common/modal/alert/alert/AgeModal.vue';
import BIRTHDATE from '@/components/common/modal/alert/user/BirthDateModal.vue';
import POINT_GUIDE_MODAL from '@/components/common/modal/alert/user/PointGuideModal.vue';
import MARKETING_GUIDE_MODAL from '@/components/common/modal/alert/user/MarketingGuideModal.vue';
import SOCIAL_CONSENT_GUIDE_MODAL from '@/components/common/modal/alert/user/SocialConsentGuideModal.vue';
import CONFIRM from '@/components/common/modal/alert/confirm/confirm.vue';
import SUB_CONFIRM from '@/components/common/modal/alert/confirm/subConfirm.vue';
import WHOLE from '@/components/common/modal/alert/whole/whole.vue';
import MARKETING from '@/components/common/modal/alert/user/marketingAlert.vue';
import RADIO_CONTENT_MODAL from '@/components/common/modal/alert/memorial/RadioContentModal.vue';
import MEMORIAL_CHAT_CONTENT_MODAL from '@/components/common/modal/alert/memorial/MemorialChatRadioContentModal.vue';
import EMOTICON_SELECT from '@/components/common/modal/alert/funeral/EmoticonSelect.vue';
import MEMORIAL_EMOTICON_SELECT from '@/components/common/modal/alert/memorial/MemorialEmoticonSelect.vue';
import NON_MEMBER_ALERT from '@/components/common/modal/alert/funeral/nonMemberAlert.vue';
import RADIO_SELECTOR_MODAL from '@/components/common/modal/alert/user/RadioSelectorModal.vue';
import SMILE_RADIO_MODAL from '@/components/common/modal/alert/smile/SmileRadioModal.vue';
import AUTHORITY from '@/components/common/modal/alert/alert/Auth.vue';
import TUTORIAL from '@/components/common/modal/alert/alert/TutorialView.vue';
import FUNERAL from '@/components/common/modal/alert/obituary/FuneralModal.vue';
import BANK_CODE from '@/components/common/modal/alert/obituary/BankCodeModal.vue';
import END_FUNERAL from '@/components/common/modal/alert/obituary/EndFuneralModal.vue';
import TICKET_LIST from '@/components/common/modal/alert/memorial/TicketList.vue';
import COMPANY from '@/components/common/modal/alert/alert/CompanyModal.vue';
import KAKAO_POST from '@/components/common/modal/alert/obituary/KakaoPostModal.vue';
import ANNIVERSARY from '@/components/common/modal/alert/memorial/AnniversaryModal.vue';
import SearchMemberModal from '@/components/common/modal/alert/memorial/SearchMemberModal.vue';
import DIARY_EVENTS_MODAL from '@/components/common/modal/DiaryEventsModal.vue';
import BankListModal from '@/components/common/modal/BankListModal.vue';
import SMILE_IMAGE_MODAL from '@/components/common/modal/smile/SmileImageModal.vue';

import FUNERAL_CHAT_RADIO_MODAL from '@/components/common/modal/alert/funeral/FuneralChatRadioModal.vue';
import WELL_PASSWORD_MODAL from '@/components/common/modal/WellPasswordInput.vue';

import SMILE_EMOTICON_SELECT from '@/components/common/modal/alert/smile/SmileEmoticonSelect.vue';
import SMILE_CHAT_COMMENT_MODAL from '@/components/common/modal/alert/smile/SmileChatCommentModal.vue';

import CreateNoticeModal from '@/views/memorial/modal/CreateNoticeModal.vue';

import WELL_VIDEO_MODAL from '@/views/welldying/components/WellDyingVideoModal.vue';

/** 전체화면 **/
import IMAGE_MODAL from '@/components/common/modal/ImageModal.vue';
import NAVER_SEARCH from '@/components/common/modal/NaverSearch.vue';

import BUSINESS_TICKET_MODAL from '@/components/common/modal/alert/business/BusinessTicketModal.vue';
import BUSINESS_LIST_MODAL from '@/components/common/modal/alert/business/BusinessListModal.vue';
import BUSINESS_SEARCH_MODAL from '@/components/common/modal/alert/business/BusinessSearchModal.vue';
import BUSINESS_ADDRESS_SETTING from '@/components/common/modal/alert/business/BusinessAddressSetting.vue';
import BUSINESS_ADDRESS_DETAIL from '@/components/common/modal/alert/business/BusinessAddressDetail.vue';
import IMAGE_ZOOM_MODAL from '@/components/common/modal/alert/business/ImageZoomModal.vue';
import AD_RESTRICTED_CATEGORY_MODAL from '@/components/common/modal/alert/business/AdRestrictedCategoryModal.vue';
import REGISTER_DONE_MODAL from '@/components/common/modal/alert/business/RegisterDoneModal.vue';
import EVENT_TICKET_SHORT_MODAL from '@/components/common/modal/alert/business/EventTicketShortModal.vue';
import BUSINESS_REPORT_MODAL from '@/components/common/modal/alert/business/BusinessReportModal.vue';
import MARKETING_SUBSCRIBE_MODAL from '@/components/common/modal/alert/business/MarketingSubscribeModal.vue';
import NAVI_SELECT from '@/components/common/modal/alert/business/NaviSelectModal.vue';
import BUSINESS_SHARE_SHEET from '@/components/common/modal/alert/business/BusinessShareSheet.vue';
import FRANCHISE_REQUEST_SHEET from '@/components/common/modal/alert/business/FranchiseRequestSheet.vue';
import QR_PRE_ORDER_SHEET from '@/components/common/modal/alert/business/QrPreOrderSheet.vue'; // 260923 대표 회의: 스마트스토어 오픈 전 현판 사전 신청

import MENU_MODAL from '@/views/more/MenuModal.vue';
import SMILE_BANK_MODAL from '@/components/common/modal/alert/smile/SmileBankModal.vue';
import WELL_FLOATING_MENU_MODAL from '@/views/welldying/components/FloatingMenuModal.vue';

import REPORT_REASON_MODAL from '@/components/common/modal/ReportReasonModal.vue';
import IFRAME_MODAL from '@/components/common/modal/smile/IframeModal.vue';
import MAIN_MODAL from '@/components/common/modal/MainModal.vue';

export const modalNames = {
  BankListModal,
  AGE_MODAL,
  POINT_GUIDE_MODAL,
  MARKETING_GUIDE_MODAL,
  SOCIAL_CONSENT_GUIDE_MODAL,
  BANK_CODE,
  SMILE_BANK_MODAL,
  FUNERAL,
  ALERT,
  CONFIRM,
  SUB_CONFIRM,
  WHOLE,
  BIRTHDATE,
  MARKETING,
  RADIO_CONTENT_MODAL,
  MEMORIAL_CHAT_CONTENT_MODAL,
  EMOTICON_SELECT,
  MEMORIAL_EMOTICON_SELECT,
  SMILE_EMOTICON_SELECT,
  SMILE_CHAT_COMMENT_MODAL,
  NON_MEMBER_ALERT,
  RADIO_SELECTOR_MODAL,
  SMILE_RADIO_MODAL,
  AUTHORITY,
  TUTORIAL,
  TICKET_LIST,
  COMPANY,
  END_FUNERAL,
  KAKAO_POST,
  ANNIVERSARY,
  FAMILY_MEMBER: SearchMemberModal,
  CreateNoticeModal,

  FUNERAL_CHAT_RADIO_MODAL,

  IMAGE_MODAL,
  WELL_VIDEO_MODAL,
  SMILE_IMAGE_MODAL,
  NAVER_SEARCH,
  IFRAME_MODAL,

  DIARY_EVENTS_MODAL,
  WELL_PASSWORD_MODAL,

  BUSINESS_TICKET_MODAL,
  BUSINESS_SEARCH_MODAL,
  BUSINESS_ADDRESS_SETTING,
  BUSINESS_ADDRESS_DETAIL,
  BUSINESS_LIST_MODAL,
  IMAGE_ZOOM_MODAL,
  AD_RESTRICTED_CATEGORY_MODAL,
  REGISTER_DONE_MODAL,
  EVENT_TICKET_SHORT_MODAL,
  BUSINESS_REPORT_MODAL,
  MARKETING_SUBSCRIBE_MODAL,
  NAVI_SELECT,
  BUSINESS_SHARE_SHEET,
  FRANCHISE_REQUEST_SHEET,
  QR_PRE_ORDER_SHEET,

  MENU_MODAL,
  WELL_FLOATING_MENU_MODAL,

  REPORT_REASON_MODAL,
  MAIN_MODAL
};
